import doRequest from "services/helpers";
import { getToken } from "services/auth/tokenAuth";
import { getUserId } from "services/storage/general";

export const requestGetResourceSchedules = async ({
    libraryId, resourceModuleId,
    spaceId, resourceTypeId
}) => {
    const [result, err] = await doRequest(
        "/Recurso/ListarHorarios", "POST", 
        {
            idEspacio: resourceModuleId,
            idPolideportivo: spaceId ? spaceId : null,
            idBiblioteca: libraryId ? libraryId : null,
            idRecurso: resourceTypeId ? resourceTypeId : null,
        }, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    const {
        horariosAtencion,
        diasNoHabiles
    } = data.data?.informacion;
    return {
        schedules: horariosAtencion.map(({
            idHorarioAtencion, 
            nombreDia, 
            horaInicio, 
            horaFin
        }) => ({
            id: idHorarioAtencion,
            dayName: nombreDia,
            timeStart: horaInicio,
            timeEnd: horaFin
        })),
        nonBusinessDays: diasNoHabiles.map(({
            idDiaNoHabil, 
            fecha, 
            motivo
        }) => ({
            id: idDiaNoHabil, 
            date: fecha, 
            reason: motivo
        }))
    };
}
const FATAL_ERROR = {
    success: false,
    message: null
};
export const requestCreateResourceSchedule = async ({
    resourceModuleId, spaceId,
    libraryId, resourceTypeId, 
    daysIds, timeStart, timeEnd
}) => {
    const [result, err] = await doRequest(
        "/Recurso/CrearHorarioAtencion", "POST",
        {
            idEspacio: resourceModuleId,
            idPolideportivo: spaceId ? spaceId : null,
            idBiblioteca: libraryId ? libraryId : null,
            idRecurso: resourceTypeId ? resourceTypeId : null,
            idsDias: daysIds,
            horaInicio: timeStart,
            horaFin: timeEnd,
            codigoUsuario: getUserId()
        }, getToken());
    if (err)
        return {
            ...FATAL_ERROR,
            days: [] 
        };
    const { data } = result;
    if (![1, 0].includes(data?.state))
        return { ...FATAL_ERROR };
    return {
        success: data.data?.exito,
        message: data.data?.mensaje || null,
        days: data.data?.listaDias || []
    };
}
export const requestCreateResourceNonBusinessDay = async ({
    resourceModuleId, spaceId,
    libraryId, resourceTypeId, 
    date, reason
}) => {
    const [result, err] = await doRequest(
        "/Recurso/CrearDiaNoHabil", "POST",
        {
            idEspacio: resourceModuleId,
            idPolideportivo: spaceId ? spaceId : null,
            idBiblioteca: libraryId ? libraryId : null,
            idRecurso: resourceTypeId ? resourceTypeId : null,
            fecha: date,
            motivo: reason,
            codigoUsuario: getUserId()
        }, getToken());
    if (err)
        return { ...FATAL_ERROR };
    const { data } = result;
    if (![1, 0].includes(data?.state))
        return { ...FATAL_ERROR };
    return {
        success: data.data?.exito,
        message: data.data?.mensaje || null
    };
}
export const requestDeleteResourceSchedule = async scheduleId => {
    const [result, err] = await doRequest(
        "/Recurso/EliminarHorarioAtencion", "POST",
        {
            idHorarioAtencion: scheduleId,
            codigoUsuario: getUserId()
        }, getToken());
    if (err)
        return { ...FATAL_ERROR };
    const { data } = result;
    if (![1, 0].includes(data?.state))
        return { ...FATAL_ERROR };
    const { exito } = data.data;
    return {
        success: exito,
        message: data.data?.mensaje || null
    };
}
export const requestDeleteResourceNonBusinessDay = async nonBusinessDayId => {
    const [result, err] = await doRequest(
        "/Recurso/EliminarDiaNoHabil", "POST",
        {
            idDiaNoHabil: nonBusinessDayId,
            codigoUsuario: getUserId()
        }, getToken());
    if (err)
        return { ...FATAL_ERROR };
    const { data } = result;
    if (data?.state !== 1)
        return { ...FATAL_ERROR };
    const { exito } = data.data;
    return {
        success: exito,
        message: data.data?.mensaje || null
    };
}